import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { eAlertSeverity, Notification, NotificationService } from 'reg-hub-common';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationComponent {
  @Input() notification!: Notification;

  constructor(
    private notificationService: NotificationService,
    private router: Router) {}

  ngOnInit(): void {}

  removeNotification() {
    this.notificationService.removeNotification(this.notification.id);
  }

  // High and Severe alerts get a severity-coloured header so they stand out from order notifications
  get headerClass(): string {
    switch (this.notification.alert?.alertSeverityID) {
      case eAlertSeverity.High:
        return 'notification-header-high';
      case eAlertSeverity.Severe:
        return 'notification-header-severe';
      default:
        return '';
    }
  }

  viewAlert() {
    this.notificationService.removeNotification(this.notification.id);

    this.router.navigate(['alerts', this.notification.alert?.id]);
  }

  viewOrder() {
    this.notificationService.removeNotification(this.notification.id);
    
    this.router.navigate(['orders', this.notification.order?.id]);
  }
}
